var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.25 125.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.25 125.4H2.46v-16.82l40-42.65a98.3 98.3 0 0012.21-15.72 25.17 25.17 0 003.95-12.74q0-8.25-4.16-13T42.57 19.8q-8.34 0-13.13 5.73t-4.8 15.08H0A40.51 40.51 0 015.4 20 37.93 37.93 0 0120.65 5.31 46.32 46.32 0 0143 0q19.1 0 29.68 9.18t10.58 25.91a41.46 41.46 0 01-4.76 18.69Q73.75 63.29 62.19 76l-28.12 29.61h53.18z",
    fill: "#fff"
  })));
}
Svg02.displayName = '02';
export default Svg02;